import { useState } from 'react';
import { CURRENCIES } from '@linearb/linjs-common';
import _ from 'lodash';

const useFormCostSetting = costSetting => {
  const [isEnabled, setIsEnabled] = useState(costSetting.isEnabled);
  const [value, setValue] = useState(costSetting.value || 100000);
  const [currency, setCurrency] = useState(
    _.get(costSetting, 'currency.key', CURRENCIES.USD.key)
  );

  return {
    isEnabled,
    setIsEnabled,
    value,
    setValue,
    currency,
    setCurrency
  };
};

export default useFormCostSetting;
